import React from 'react';
import { Button } from 'react-bootstrap';
import { BsWhatsapp } from 'react-icons/bs';

const Whatsapp = () => {
  return (
    <Button
    variant='none' 
    href="https://api.whatsapp.com/send/?phone=201063920694&text&type=phone_number&app_absent=0"
    target="_blank"
    >
      <BsWhatsapp style={{color:"green",fontSize:"56px",position: "fixed",bottom:"20px",right:"20px"}}/>
    </Button>
  )
}

export default Whatsapp;
